export interface SidebarRouteEntry {
    activeKey: string
    variant?: 1 | null
}

// Keyed by the route path exactly as registered via utility.routeData(path, ...)
// for that page (i.e. the first path segment after /dashboardv2/).
// Routes with no entry here render without a sidebar (e.g. onboarding wizard
// screens like get-started/setup-success/invite-team).
export const sidebarRouteConfig: Record<string, SidebarRouteEntry> = {
    'home': { activeKey: 'home' },
    'audit-trail': { activeKey: 'audit-trail' },
    'roles-permissions': { activeKey: 'roles-permissions' },
    'team-members': { activeKey: 'institutions' },
    'institution-profile': { activeKey: 'institutions' },
    'institution-branding': { activeKey: 'institutions' },
    'business-logic': { activeKey: 'institutions' },
    'app-generation': { activeKey: 'institutions' },
    'auto-deployment': { activeKey: 'institutions' },
    'feed-notification': { activeKey: 'institutions' },
    'support-management': { activeKey: 'support-management' },
    'help-resources': { activeKey: 'help-resources' },
    // Sidebar variant depends on the signed-in user's role, not the route —
    // see useSidebarVariantOverride/DashboardLayout.
    'profile': { activeKey: 'profile' },
    'customer-management-list': { activeKey: 'customer-management' },
    'customer-management-cbp-list': { activeKey: 'customer-management' },
    'customer-management-account-upgrade': { activeKey: 'customer-management' },
    'institution-creation': { activeKey: 'institutions', variant: 1 },
    'institution-list': { activeKey: 'institutions', variant: 1 },
    'institution-configuration': { activeKey: 'institutions', variant: 1 },
    'institution-details': { activeKey: 'institutions', variant: 1 },
    'survey-report': { activeKey: 'survey-management', variant: 1 },
    'survey-management': { activeKey: 'survey-management', variant: 1 },
    'survey-details': { activeKey: 'survey-management', variant: 1 },
}
